import { DRReponse2ListItem } from "../../dr/Components/list/DRlistFuncs";
import { importJSON } from "../../lib/importJSON";
import { FormatDateDataType } from "../../util/genericDateAndTimeFuncs";
import { DischargeLenderItem, LenderContactType, MortgageLenderItem } from "../MortgageLender/MortgageLenderTypes";
import { ThirdPartyListItem } from "../ThirdPartyList/ThirdPartyTypes";
import { FileListItem } from "../fileList/fileList";
import { NavObjectType, ProvincesShortCode } from "../navigationTypes";
import { ListName } from "./List";
import { BuildThirdPartyListLink } from "../ThirdPartyList/ThirdPartyFuncs";
import { Dispatch } from "react";
import { convertXMLItemsToJSON } from "../../lib/xmlFuncs";
import { ID_FIRMCONTACT, TEXTID_FIRMCONTACT } from "../../../../libs/taskmanagement/src/taskTypes";
import { parseProfile, updateStandardItem } from "../Settings/TaskManagementSettings/taskFuncs";
import KeyDate from "../taskSystem/KeyDate";

export type ListExtraData = {
    extraQueryFilter?: Record<string, string>,
    extraSearchData? : string[],
    sortingObj? : (string | boolean)[],
    mortgageBranchEntry?: MortgageLenderItem,
    signal? : AbortSignal,
    suggestions? : boolean,
}

export function fetchData(
    firmId: number,
    prov: ProvincesShortCode,
    sid: string,
    filePage: number,
    searchText: string,
    searchType: string,
    extraData?: ListExtraData,

): Promise<Response>[] {
    try {
        if (firmId && sid) {


            const extraDataObject = {};
           
            if (extraData?.extraSearchData) {
                let cleanFilters = extraData.extraSearchData.filter((value) => value != "");
                if (cleanFilters.length > 0) {
                    extraDataObject['systemFilters'] = cleanFilters;
                }
            }

            if (extraData?.sortingObj) {
                extraDataObject['sortingObj'] = extraData.sortingObj;
            }

            if (extraData?.suggestions) {
                extraDataObject['suggestions'] = extraData.suggestions;
            }

            var signalData = null;
            if (extraData?.signal) {
                signalData = extraData.signal;
            }

            const body = {
                page: filePage,
                searchType: searchType,
                search: searchText,
                extraData: extraDataObject,
            }

            if (extraData?.extraQueryFilter) {
                Object.keys(extraData.extraQueryFilter).forEach(filterKey => {
                    body[filterKey] = extraData.extraQueryFilter[filterKey];
                })
            }

            const responseData = fetch(`/${process.env.REACT_APP_RWAPI_ENDPOINT}/api/${prov}/${firmId}/get/list?SessionID=${sid}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body),
                signal: signalData
            });
    
            const responsePromises = [responseData];
            if (searchType === "lenders" && searchText > "") {
                // search miscellaneous
                const secondBody = {
                    page: 1,
                    searchType: "sub_lenders",
                    search: searchText,
                    multiPredicate: [1000001, 1]
                };

                const secondResponseData = fetch(`/${process.env.REACT_APP_RWAPI_ENDPOINT}/api/${prov}/${firmId}/get/list?SessionID=${sid}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(secondBody)
                });
                responsePromises.push(secondResponseData);
            }

            return responsePromises;
        }
        return [];
    } catch (e) {
        if (e.name === 'AbortError') {
            console.log("Aborted");
            return [];
        }
        console.log(e);
        return [];
    }
}

export function buildListHeaders<T>(
    columns: string[],
    sort: (sortingOrder: boolean, column: string, data: T[], setData: React.Dispatch<React.SetStateAction<T[]>>) => void,
    sortingOrder: boolean,
    data: T[],
    setData: (val: T[]) => void,
    setSortingOrder: (val: boolean) => void
) {
    const handleClick = (e: React.MouseEvent<HTMLTableCellElement, MouseEvent>) => {
        sort(!sortingOrder, (e.target as HTMLTableCellElement).getAttribute("data-name"), data, setData);
        setSortingOrder(!sortingOrder);
    }
    return (
        <tr>
            {columns.map(col => {
                switch (col) {
                    case 'indexattributevalue':
                        return (
                            <th key={`th-${col}`} style={{ cursor: "pointer" }} data-name={col} onClick={handleClick}>
                                <i className="fa-solid fa-sort fa-indicator"></i>
                                Name
                            </th>
                        )
                    case 'FirmName':
                        return (
                            <th key={`th-${col}`} style={{ cursor: "pointer" }} data-name={col} onClick={handleClick}>
                                <i className="fa-solid fa-sort fa-indicator"></i>
                                Firm
                            </th>
                        )
                    case 'Address':
                        return (
                            <th key={`th-${col}`} style={{ cursor: "pointer" }} data-name={col} onClick={handleClick}>
                                <i className="fa-solid fa-sort fa-indicator"></i>
                                Location
                            </th>
                        )
                    default:
                        return <></>
                }
            })}
        </tr>
    )
}

export function handleSetData<T>(
    listName: ListName,
    responsePromises: Promise<Response>[],
    setData: (data: T[]) => void,
    setHasMoreData: React.Dispatch<React.SetStateAction<boolean>>,
    setFreesearchData: React.Dispatch<React.SetStateAction<T[]>>,
    existingData?: T[],
    curDataPage?: number,
    setDataPage?: React.Dispatch<React.SetStateAction<number>>
) {
    if (existingData == null) {
        setData([]);
    }
    switch (listName) {
        case "FileList":
            setFileList(
                responsePromises,
                setData,
                setHasMoreData,
                setFreesearchData,
                existingData,
                curDataPage,
                setDataPage,
            );
            break;
        case "MortgageLenderList":
            setLenderList(
                responsePromises,
                setData,
                setHasMoreData,
            );
            break;
        case "DischargeLenderList":
            setDischargeLenderList(
                responsePromises,
                setData,
                setHasMoreData,
            );
            break;
        case "SuggestedList":
            setSuggestedList(
                responsePromises,
                setData,
            );
            break;
        case "DRFileList":
            setDRFileList(
                responsePromises,
                setData,
                setHasMoreData,
                setFreesearchData,
            );
            break;
        case "TaskList":
            setTaskList(
                responsePromises,
                setData,
                setHasMoreData,
                setFreesearchData
            );
            break;
        default:
            setThirdPartyList(
                responsePromises,
                setData,
                setHasMoreData,
                existingData,
                curDataPage,
                setDataPage,
            );
            break;
    }
}

function setFileList<T>(
    responsePromises: Promise<Response>[],
    setData: (data: T[]) => void,
    setHasMoreData: React.Dispatch<React.SetStateAction<boolean>>,
    setFreesearchData: React.Dispatch<React.SetStateAction<T[]>>,
    existingData?: T[],
    curDataPage?: number,
    setDataPage?: React.Dispatch<React.SetStateAction<number>>,
) {
    let initObj: FileListItem = {
        AppID: -1,
        MatterNumber: "",
        PSM: "P",
        LawyerID: "",
        ClosingDate: "",
        ClientName: "",
        LawyerName: "",
        PropertyType: "",
        FirmContact: "",
        PropertyAddress: "",
        ContractDate: "",
        RequisitionDate: "",
        ReLine: "",
    };
    let defaultSearchedData: FileListItem[] = [];
    const DateColumns = ["ClosingDate", "RequisitionDate", "ContractDate", "InterimClosingDate"];
    responsePromises[0]?.then(
        response => {
            response.json().then(
                data => {
                    if (data.ok) {
                        data.result.map((file) => importJSON(file, initObj));
                        data.result.forEach((e) => {
                            DateColumns.forEach(d => {
                                if (e[d]) {
                                    e[d] = FormatDateDataType(e[d], "dfca")
                                }
                            });
                        })
                        setHasMoreData(data.result.length >= process.env.REACT_APP_FILELIST_PAGE_SIZE);
                        defaultSearchedData = data.result;
                        if (existingData) {
                            const newData = [...existingData, ...data.result];
                            setData(newData);
                        } else {
                            setData(data.result);
                        }
                        if (curDataPage && setDataPage && existingData) {
                            setDataPage(curDataPage + 1)
                        }
                        if (responsePromises.length === 1) {
                            // no freesearch promise
                            setFreesearchData([]);
                        }
                    }
                }
            )
        }
    );
    responsePromises[1]?.then(
        response => {
            response.json().then(
                data => {
                    data.result.map((file) => importJSON(file, initObj));
                    // filter files in defaultSearchedData
                    const filteredData = data.result.filter((file) => defaultSearchedData.findIndex(f => f.AppID === file.AppID) === -1);
                    filteredData.forEach((e) => {
                        DateColumns.forEach(d => {
                            if (e[d]) {
                                e[d] = FormatDateDataType(e[d], "dfca")
                            }
                        });
                    })
                    setFreesearchData(filteredData);
                }
            )
        }
    )
}

function setSuggestedList<T>(
    responsePromises: Promise<Response>[],
    setData: (data: T[]) => void,
) {
    let thirdPartyObj: ThirdPartyListItem = {
        qpickrepository_id: -1,
        indexattributevalue: "",
        LawyerID: "",
        Name: "",
        Address: "",
        DirectPhone: "",
        FirmName: "",
    };
    responsePromises[0]?.then(
        response => {
            response.json().then(
                data => {
                    var recData = data.result.map((queryObj) => importJSON(queryObj, thirdPartyObj));

                    if (recData.length > 10) {
                        recData = recData.slice(0, 10);
                    }

                    setData([]);
                    setData(recData);
                })
        });
}

function setThirdPartyList<T>(
    responsePromises: Promise<Response>[],
    setData: (data: T[]) => void,
    setHasMoreData: React.Dispatch<React.SetStateAction<boolean>>,
    existingData?: T[],
    curDataPage?: number,
    setDataPage?: (dataPage: number) => void,
) {
    let thirdPartyObj: ThirdPartyListItem = {
        qpickrepository_id: -1,
        indexattributevalue: "",
        LawyerID: "",
        Name: "",
        Address: "",
        DirectPhone: "",
        FirmName: "",
    };
    responsePromises[0]?.then(
        response => {
            response.json().then(
                data => {
                    data.result.map((queryObj) => importJSON(queryObj, thirdPartyObj));
                    setHasMoreData(data.result.length >= process.env.REACT_APP_FILELIST_PAGE_SIZE);

                    if (existingData) {
                        const newData = [...existingData, ...data.result];
                        setData(newData);
                    } else {
                        setData(data.result);
                    }                 
                    if (curDataPage && setDataPage) {
                        setDataPage(curDataPage + 1);
                    }
                })
        });
}

function setLenderList<T>(
    responsePromises: Promise<Response>[],
    setData: (data: T[]) => void,
    setHasMoreData: React.Dispatch<React.SetStateAction<boolean>>,
) {
    let mortgageLenderObj: MortgageLenderItem = {
        LDDLenderID: -1,
        LenderID: -1,
        Name: "",
        NoCreditEndorsement: "",
        Active: "",
        Website: "",
        AcceptCollateralLOCLoan: "",
        AcceptConstructionLoan: "",
        RequireSubsearchOfTitle: "",
        TPConfirmedSpecialText: "",
        branches: [],
        BranchCount: 0,
        LenderProgramID: "",
        PrivateLender: "",
    };

    let newData = [];
    responsePromises[0]?.then(
        response => {
            response.json().then(
                data => {
                    let LenderList = data.result.map((queryObj) => importJSON(queryObj, mortgageLenderObj));
                    newData = [...newData, ...LenderList];
                    setData(newData);
                    setHasMoreData(false);
                }
            )
        })
    responsePromises[1]?.then(
        response => {
            response.json().then(
                data => {
                    let misLender: MortgageLenderItem = {
                        LDDLenderID: 1000001,
                        LenderID: 1000000001,
                        Name: "Miscellaneous Lender",
                        NoCreditEndorsement: "",
                        Active: "",
                        Website: "",
                        AcceptCollateralLOCLoan: "",
                        AcceptConstructionLoan: "",
                        RequireSubsearchOfTitle: "",
                        TPConfirmedSpecialText: "",
                        branches: [],
                        BranchCount: 0,
                        LenderProgramID: "",
                        PrivateLender: "",
                    }
                    let initBranch: LenderContactType = {
                        LenderContactID: 0,
                        LDDLenderID: 0,
                        LenderID: 0,
                        LawyerID: "",
                        Branch: "",
                        TransitNum: 0,
                        XMLData: "",
                        SortOrder: "",
                        isDischarge: "",
                        isDefault: "",
                        LenderProgramID: "",
                        isBranch: true,
                        LenderName: "",
                    }
                    let LenderList = data.result.map((queryObj) => importJSON(queryObj, initBranch));
                    if (LenderList.length > 0) {
                        misLender.BranchCount = LenderList.length;
                        misLender.branches = LenderList;
                        newData = [...newData, misLender];
                        setData(newData);
                    }
                }
            )
        })
}


function setDischargeLenderList<T>(
    responsePromises: Promise<Response>[],
    setData: (data: T[]) => void,
    setHasMoreData: React.Dispatch<React.SetStateAction<boolean>>,
) {
    let dischargeLenderObj: DischargeLenderItem = {
        LDDLenderID: -1,
        LenderID: -1,
        Name: "",
        NoCreditEndorsement: "",
        Active: "",
        Website: "",
        AcceptCollateralLOCLoan: "",
        AcceptConstructionLoan: "",
    };
    responsePromises[0]?.then(
        response => {
            response.json().then(
                data => {
                    data.result.map((queryObj) => importJSON(queryObj, dischargeLenderObj));
                    setHasMoreData(data.result.length >= process.env.REACT_APP_FILELIST_PAGE_SIZE);
                    setData(data.result);
                    setHasMoreData(false);
                }
            )
        })
}


export function BuildThirdPartyRecommendationsLink(
    columns: string[],
    dataroot: any,
    nodeName: string,
    navObj?: NavObjectType,
    navigateContext?: (navObject: NavObjectType, init?: boolean) => void,
    province?: ProvincesShortCode,
    listName?: string,
    lenderEntry?: MortgageLenderItem,
    searchString?: string,
    dispatch?: React.Dispatch<any>,
    skipSetThirdPartyData?: boolean
) {
    switch (listName) {
        // case 'MortgageBranchList':
        //     //mortgage branches
        //     return buildBranchLink(lenderEntry, listName, "Mortgage_lender");
        // case 'AllMortgageLenderList':
        //     //all mortgage lenders
        //     return buildMortgageLenderLink(listName);
        default:
            //all lawyers and notaries
            return BuildThirdPartyListLink(columns, dataroot, nodeName, navObj, navigateContext, province, searchString, dispatch, skipSetThirdPartyData);
    }
}

function setDRFileList<T>(
    responsePromises: Promise<Response>[],
    setData: (data: T[]) => void,
    setHasMoreData: React.Dispatch<React.SetStateAction<boolean>>,
    setFreesearchData: React.Dispatch<React.SetStateAction<T[]>>,
) {
    responsePromises[0]?.then(
        response => {
            response.json().then(
                data => {
                    data.result = data.result.map((entry) => DRReponse2ListItem(entry));
                    setHasMoreData(data.result.length >= process.env.REACT_APP_FILELIST_PAGE_SIZE);
                    setData(data.result);
                    setHasMoreData(false);
                    setFreesearchData(data.result);
                }
            )
        })
}

function setTaskList<T>(
    responsePromises: Promise<Response>[],
    setData: (data: T[]) => void,
    setHasMoreData: React.Dispatch<React.SetStateAction<boolean>>,
    setFreesearchData: React.Dispatch<React.SetStateAction<T[]>>,
) {
    responsePromises[0]?.then(
        response => {
            response.text().then(
                data => {
                    const parser = new DOMParser();
                    const xmlDoc = parser.parseFromString(data, "text/xml");
                    if (xmlDoc){
                        const items = xmlDoc.getElementsByTagName('items')[0];
                        if (!items){
                            return []
                        }
                        let standardTaskItems = convertXMLItemsToJSON(items.getElementsByTagName('standardCalendarItems')[0]);
                        let defaultStandardItems = convertXMLItemsToJSON(items.getElementsByTagName('standardCalendarItems')[1]);
                        if(!defaultStandardItems || defaultStandardItems.length === 0){
                            defaultStandardItems = convertXMLItemsToJSON(xmlDoc.getElementsByTagName('standardCalendarItems')[1]);
                        }
                        
                        if (defaultStandardItems && defaultStandardItems.length > 0) {
                            standardTaskItems.forEach(standardItem => {
                                const defaultItem = defaultStandardItems.find(item => item.typeID === standardItem.typeID);
                                if (defaultItem) {
                                    standardItem = updateStandardItem(standardItem, defaultItem);
                                }
                                if(!standardItem.idsAssignedTo){
                                    standardItem.idsAssignedTo = `${ID_FIRMCONTACT}-${ID_FIRMCONTACT}-${TEXTID_FIRMCONTACT}` ;
                                }
                            });
                            
                            defaultStandardItems.forEach(defaultItem => {
                                const exists = standardTaskItems.some(item => item.typeID === defaultItem.typeID);
                                if (!exists) {
                                    standardTaskItems.push(defaultItem);
                                }
                            });
                        }
                        
                        const userTaskItems = convertXMLItemsToJSON(items.getElementsByTagName('userCalendarItems')[0]);
                        let result = [...standardTaskItems, ...userTaskItems];
                        result = parseProfile(result);
                        result.sort((a, b) => {
                            if (a.output !== b.output) {
                                return a.output === "1" ? -1 : 1;
                            }
                            return a.description.localeCompare(b.description);
                        });
                        const filteredResult = result.filter(task => task.output === "1");
                        
                        setHasMoreData(false);
                        setData(result); 
                        setFreesearchData(filteredResult); 
                    }
                }
            )
        })
}
